import api from "services/api";
import qs from "query-string";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { decodeToken } from "react-jwt";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import LoginLayout from "layouts/upstyled/SigninLayout";

import moment from "moment";
import toast from "react-hot-toast";
import PasswordChecklist from "react-password-checklist";
//import LetterLogo from "components/UpStyled/LetterLogo";
import UpStyledLogo from "components/UpStyled/UpStyledLogo";

import { Link, useNavigate, useLocation } from "react-router-dom";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  let location = useLocation();

  const url = location.href ? location.href : location.pathname + location.search;
  const parsed = qs.parseUrl(url);

  let token = null;
  if (parsed?.query?.token) {
    try {
      token = decodeToken(parsed.query.token);
    } catch (e) {
      token = null;
    }
  }
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isValidPassword, setIsValidPassword] = useState(false);

  const email = token?.email || parsed?.email || "";

  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      password: "",
      repeat_password: "",
    },
  });

  const handleAcceptInvite = async (data) => {
    if (!isValidPassword) {
      return toast.error("Your password is invalid!");
    }

    const payload = {
      token: parsed.query.token,
      password: data.password,
      email: email,
    };

    try {
      await api.users.resetPassword(payload);
      toast.success("Successfully reset your password!");
      navigate("/login");
    } catch (err) {
      toast.error("Reset password failed");
    }
  };

  if (!token) {
    return (
      <LoginLayout>
        <div className="flex h-full w-full items-center justify-center">
          <Card className="flex min-h-[240px] bg-grey-0 rounded-rounded justify-center">
            <div className="flex flex-col py-12 w-full px-12 items-center">
              <div className="h-full flex flex-col gap-y-2 text-center items-center justify-center">
                <span className="inter-large-semibold text-grey-90 text-xl">
                  Your link is invalid
                </span>
                <span className="inter-base-regular text-grey-50 mt-2">
                  Please try to contact <a href="mailto:support@upstyled.co">support@upstyled.co</a>
                </span>
              </div>
            </div>
          </Card>
        </div>
      </LoginLayout>
    );
  } else if (token && token.exp < moment().unix()) {
    return (
      <LoginLayout>
        <div className="flex h-full w-full items-center justify-center">
          <Card className="flex min-h-[240px] bg-grey-0 rounded-rounded justify-center">
            <div className="flex flex-col py-12 w-full px-12 items-center">
              <div className="h-full flex flex-col gap-y-2 text-center items-center justify-center">
                <span className="inter-large-semibold text-grey-90 text-xl">
                  Your link was expired at {moment.unix(token.exp).format("YYYY-MM-DD HH:mm:ss")}
                </span>
                <span className="inter-base-regular text-grey-50 mt-2">
                  Please try to contact <a href="mailto:support@upstyled.co">support@upstyled.co</a>
                </span>
              </div>
            </div>
          </Card>
        </div>
      </LoginLayout>
    );
  }

  return (
    <LoginLayout>
      <div className="flex h-full w-full items-center justify-center">
        <Card className="flex min-h-[540px] bg-grey-0 rounded-rounded justify-center items-center px-6">
          <div className="flex flex-col pt-8 w-full items-center">
            <span className="inter-2xlarge-semibold mt-2 text-grey-90 px-12">
              <UpStyledLogo sx={{ height: 80 }} />
            </span>
          </div>
          <span className="inter-2xlarge-semibold mt-2 text-grey-90">Reset your password</span>
          <form onSubmit={handleSubmit(handleAcceptInvite)}>
            <div className="flex flex-col my-4 w-full items-start px-4">
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        required
                        textTransform="capitalize"
                      >
                        Email
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput placeholder="Email" value={email} readOnly disabled />
                  </SuiBox>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        required
                        textTransform="capitalize"
                      >
                        Password
                      </SuiTypography>
                    </SuiBox>

                    <SuiInput
                      placeholder="Password"
                      autoComplete="new-password"
                      type="password"
                      required
                      {...register("password")}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </SuiBox>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        required
                        textTransform="capitalize"
                      >
                        Confirm Password
                      </SuiTypography>
                    </SuiBox>

                    <SuiInput
                      placeholder="Password"
                      autoComplete="new-password"
                      type="password"
                      required
                      {...register("repeat_password")}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </SuiBox>
                </Grid>
              </Grid>
              <div className="mb-1">
                <PasswordChecklist
                  rules={["minLength", "number", "match"]}
                  minLength={8}
                  value={newPassword}
                  valueAgain={confirmPassword}
                  iconSize={9}
                  style={{ fontSize: 12 }}
                  onChange={(isValid) => {
                    setIsValidPassword(isValid);
                  }}
                />
              </div>
            </div>
            <SuiBox
              pb={2}
              px={3}
              display="flex"
              justifyContent="end"
              alignItems={{ xs: "flex-start", sm: "center" }}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
                <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                  <SuiButton size="medium" variant="gradient" color="dark" type="submit">
                    Reset Password
                  </SuiButton>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </form>
        </Card>
      </div>
    </LoginLayout>
  );
};

export default ResetPasswordPage;
